<template>
  <div class="btn-group" role="group">
    <button id="btn-offer" type="button" class="btn btn-primary btn-lg dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      Sprawdź już teraz
    </button>
    <div class="dropdown-menu" aria-labelledby="btn-offer">
      <a class="dropdown-item text-uppercase" href="#">Oferta indywidualna</a>
      <a class="dropdown-item text-uppercase" href="#">Oferta biznesowa</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'offer-button',
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// OfferButton.vue?23f17b4e